import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, throwError } from "rxjs";
import { catchError, map, take } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { Procedimento } from "../models/procedimento.model";

@Injectable({
  providedIn: "root",
})
export class ProcedimentosService {
  private procedimentos$ = new BehaviorSubject<Procedimento[]>(null);
  constructor(private http: HttpClient) {}

  public getAll(): Observable<Procedimento[]> {
    return this.http.get<Procedimento[]>(environment.rotaProcedimentos).pipe(
      map((procedimento) =>
        procedimento.map((procedimento) =>
          new Procedimento().deserialize(procedimento)
        )
      ),
      catchError(() => throwError("procedimento não encontrado."))
    );
  }

  public getAll$(): void {
    this.http
      .get<Procedimento[]>(environment.rotaProcedimentos)
      .pipe(take(1))
      .subscribe((procedimentos) => {
        this.procedimentos$.next(procedimentos);
      });
  }

  public escutarMudancasProcedimento(): Observable<Procedimento[]> {
    return this.procedimentos$.asObservable();
  }

  public atualizarProcedimentos(procedimentos: Procedimento[]) {
    return this.procedimentos$.next(procedimentos);
  }

  public adicionarProcedimento(tipo: Procedimento) {
    const procedimentosAtuais = this.procedimentos$.value;
    this.procedimentos$.next([tipo, ...procedimentosAtuais]);
  }

  private updateProcedimentoInState(updatedProcedimento: Procedimento) {
    this.procedimentos$.pipe(take(1)).subscribe((procedimentos) => {
      // Substitui a guia atualizada na lista do BehaviorSubject
      const updatedProcedimentos = procedimentos.map((procedimento) =>
        procedimento._id === updatedProcedimento._id
          ? updatedProcedimento
          : procedimento
      );
      // Atualiza o BehaviorSubject com a nova lista
      this.procedimentos$.next(updatedProcedimentos);
    });
  }

  public edit(updatedProcedimento: Procedimento): Observable<any> {
    return this.http
      .patch(
        `${environment.rotaProcedimentos}/${updatedProcedimento._id}`,
        updatedProcedimento
      )
      .pipe(
        map(() => {
          this.updateProcedimentoInState(updatedProcedimento);
        }),
        catchError((error) =>
          throwError("Erro ao atualizar procedimento: " + error)
        )
      );
  }

  public create(procedimento: Procedimento): Observable<any> {
    return this.http.post(environment.rotaProcedimentos, procedimento).pipe(
      map((novoProcedimento: Procedimento) => {
        // Atualiza a lista localmente após sucesso na atualização do servidor
        this.adicionarProcedimento(novoProcedimento);
      }),
      catchError((error) => throwError("Erro ao criar categoria: " + error))
    );
  }

  public delete(procedimento: Procedimento): Observable<any> {
    return this.http.delete(
      environment.rotaProcedimentos + "/" + procedimento._id
    );
  }
}
